// Horizontal Line
export default function SVIDivider({ color }) {
    return (
        <section className="col-4 offset-4 col-md-2 offset-md-5">
            <div className="col-8 offset-2 col-md-4 offset-md-4">
                <hr size="3" className={"pt-1 m-0 opacity-75 text-" + (color || "danger")} />
            </div>
        </section>
    )
}